module.exports = __webpack_public_path__ + "img/returns.e327f7d8.svg";